import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import ExamEnvironment from './ExamEnvironment';
import { getPaperContent, getExamById } from '../services/indianExamsService';

export default function ExamFromPaper() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { user } = useAuth();
  const { examId, paperId } = useParams();
  const [loading, setLoading] = useState(true);
  const [paper, setPaper] = useState(state?.paper || null);
  const [examInfo, setExamInfo] = useState(state?.exam || null);

  useEffect(() => {
    let mounted = true;
    async function load() {
      setLoading(true);
      try {
        if (!examInfo && examId) {
          const ex = await getExamById(examId);
          if (mounted) setExamInfo(ex);
        }
        if (!paper && paperId) {
          const content = await getPaperContent(examId || state?.examId, paperId);
          // Normalize questions similar to caller
          let questions = [];
          if (content) {
            if (Array.isArray(content.chunks)) questions = content.chunks.flatMap(c => c.questions || []);
            else if (Array.isArray(content.questions)) questions = content.questions;
            else if (content.paper && Array.isArray(content.paper.chunks)) questions = content.paper.chunks.flatMap(c => c.questions || []);
            else if (content.paper && Array.isArray(content.paper.questions)) questions = content.paper.questions;
            else if (Array.isArray(content.data)) questions = content.data;
          }
          const paperObj = { id: paperId, questions, title: content?.title || state?.paper?.title || '' };
          if (mounted) setPaper(paperObj);
        }
      } catch (e) {
        console.error('Failed to load exam/paper for env', e);
      } finally {
        if (mounted) setLoading(false);
      }
    }
    load();
    return () => { mounted = false; };
  }, [examId, paperId]);

  if (loading) return null;
  if (!paper) {
    navigate(-1);
    return null;
  }

  const questions = paper.questions || [];
  const initialTimer = paper.duration || examInfo?.duration || 30; // minutes

  return (
    <ExamEnvironment
      examInfo={{ ...examInfo, name: paper.title || examInfo?.name }}
      candidate={{ id: user?.id, name: user?.firstName }}
      questions={questions}
      initialTimer={initialTimer * 60}
      onClose={() => navigate(-1)}
    />
  );
}
